var _rect, _rect2, _rect3, _rect4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCallLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 137,
    viewBox: "0 0 218 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 120.586,
    y: 0.0183105,
    width: 100,
    height: 115,
    rx: 10,
    transform: "rotate(15 120.586 0.0183105)",
    fill: "#399E79"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 25.8818,
    width: 100,
    height: 115,
    rx: 10,
    transform: "rotate(-15 0 25.8818)",
    fill: "#399E79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.425,
    y: 55.8762,
    width: 79,
    height: 72,
    rx: 5,
    transform: "rotate(-15 19.425 55.8762)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9663,
    y: 24.2224,
    width: 49,
    height: 15,
    rx: 5,
    transform: "rotate(-15 40.9663 24.2224)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1741,
    cy: 37.2904,
    r: 7.5,
    transform: "rotate(-15 21.1741 37.2904)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCallLog);
export default __webpack_public_path__ + "static/media/noCallLog.e9dc85f69f768f2172716a7079fc127c.svg";
export { ForwardRef as ReactComponent };